import $http from './http'
import config from './config'

export default {
  name: 'bill',
  getUrl(url) {
    return config.getUrl(this.name, url);
  },
  cashier(data) {
    return $http.post(this.getUrl(`/trade/cashier`), data);
  },
  redirect(data) {
    return $http.post(this.getUrl(`/trade/redirect`), data);
  },
  getTradeDeals(UniqueID) {
    return $http.get(this.getUrl(`/TradeDeal/GetTradeDeals?UniqueID=${UniqueID}`));
  },
  GetUserPayment(orderid, unionid) {
    return $http.get(this.getUrl(`/TradeDeal/GetUserPayment?OrderID=${orderid}&UnionID=${unionid}`));
  },
  getUserTicketStatus(data) {
    return $http.post(this.getUrl('/tradedetail/SearchUserTicket'), data)
  },
}



// WEBPACK FOOTER //
// ./src/apis/billApis.js